module.exports = __webpack_public_path__ + "static/media/sten-min.e3cf42cf.png";